import React from "react";
import "./App.css";
import ImageMerger from "./ImageMerger";
import Footer from "./Footer";

function App() {
  return (
    <div className="App">
      <ImageMerger />
      <Footer />
    </div>
  );
}

export default App;
